/** A dismissible one-line notice — the workspace's way of saying what just
 *  happened (or didn't) without a modal. */
export interface Notice {
  tone: 'info' | 'error';
  message: string;
  /** Extra lines behind a "Details" toggle (e.g. which files failed). */
  details?: string[];
}

export function NoticeBanner({ notice, onDismiss }: { notice: Notice; onDismiss: () => void }) {
  return (
    <div
      role={notice.tone === 'error' ? 'alert' : 'status'}
      className={
        'mb-3 flex items-start gap-2 rounded-md border px-3 py-2 text-sm ' +
        (notice.tone === 'error'
          ? 'border-destructive/40 bg-destructive/10 text-destructive'
          : 'border-border bg-muted/50')
      }
    >
      <div className="min-w-0 flex-1">
        <span>{notice.message}</span>
        {notice.details && notice.details.length > 0 && (
          <details className="mt-1 text-xs">
            <summary className="cursor-pointer select-none">Details</summary>
            <ul className="mt-1 list-disc pl-4">
              {notice.details.map((line, i) => (
                <li key={i} className="break-words">
                  {line}
                </li>
              ))}
            </ul>
          </details>
        )}
      </div>
      <button
        type="button"
        className="shrink-0 rounded px-1.5 text-muted-foreground hover:bg-muted/60"
        onClick={onDismiss}
        aria-label="Dismiss"
      >
        ✕
      </button>
    </div>
  );
}
